import React from "react";

import type { Trials } from "@shared/graphql.types";
import { Typography } from "@shared/ui.primitives";
import { useTrackElementViewed } from "packages/membership/tracking";

import { BeforeAfter } from "./BeforeAfter/BeforeAfter";
import * as styles from "./ClinicalTrials.css";
import { TrialResultItem } from "./TrialResultItem/TrialResultItem";

type ClinicalTrialsProps = {
  trials: Omit<Trials, "trialResults">;
};

const baseTrackingValues = {
  target: "Clinical Trials",
  location: "PDP"
};

export const ClinicalTrials: React.FC<ClinicalTrialsProps> = ({ trials }) => {
  const { title, results, sourceOfTrialResults, beforeImage, afterImage } =
    trials;

  const { ref } = useTrackElementViewed({ ...baseTrackingValues });

  return (
    <section className={styles.container} ref={ref}>
      <div className={styles.header}>
        {title && (
          <Typography as="h3" variant="subheader-3" color="primary-dark">
            {title}
          </Typography>
        )}

        {!!results?.length && (
          <div className={styles.grid}>
            {results?.map(({ label, value }) => {
              if (!label || !value) return null;
              return (
                <TrialResultItem key={label} label={label} value={value} />
              );
            })}
          </div>
        )}

        {!!sourceOfTrialResults?.length && (
          <Typography as="p" variant="smallprint-md" color="primary-dark">
            {sourceOfTrialResults}
          </Typography>
        )}
      </div>

      {beforeImage && afterImage && (
        <BeforeAfter beforeImage={beforeImage} afterImage={afterImage} />
      )}
    </section>
  );
};
